import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import Taskpane from "./taskpane";
import { MsalProvider } from "@azure/msal-react";
import { useMsalDynamic } from "../providers/MsalDynamicProvider";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

const App: React.FC = () => {
  const styles = useStyles();
  const { msalInstance } = useMsalDynamic();

  return (
    <div className={styles.root}>
      {msalInstance ? (
        <MsalProvider instance={msalInstance}>
          <Taskpane />
        </MsalProvider>
      ) : (
        <Taskpane />
      )}
    </div>
  );
};

export default App;
